import angular from 'angular';
import { uniqBy } from 'lodash';

module.exports = angular.module('common.filters.uniqBy', [])
.filter('uniqBy', () => uniqBy)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/uniqBy.js
 **/